import { useQuery } from 'react-query';
import { DocumentsAPI } from 'api/document/document-core';

export const useGetDocumentTasksById = (
  projectId: number,
  documentId: number,
) => {
  return useQuery(
    ['document-tasks', documentId],
    () => DocumentsAPI.getTasks(projectId, documentId),
    {
      enabled: !!documentId && !!projectId && documentId > 0 && projectId > 0,
    },
  );
};
